import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import dp from '../../assets/img/deepak.JPG'
import productImg from '../../assets/img/product-icon.png'
import './Sidebar.css'
class SideBar extends Component {
    state = {
       
    }

    render() {
        return (
            <div>
                <ul className="sidebar-menu">

                    {/* <h2 className="text-center sidebar-heading"><i className="fa fa-university"></i><span className="d-none d-sm-inline">SCHOOL</span></h2> */}

                    <div className="text-center sidebar-profile" >
                        <div className="side-head text-left" >                     

                            <img src={productImg}  className="product-img" />
                            <span className="product-name">
                            <span className="d-none d-sm-inline" style={{fontSize:"1rem",fontWeight:"100"}}>SCHOOL</span> <i className="fa fa-bars " style={{float:"right",padding:"15px"}}></i>
                            </span>
                        </div>
                        <br />
                        <div className="d-none d-sm-inline">
                        
                            <p className="profile-text"><span style={{fontWeight:"500"}}>{this.props.userDetails.name}</span>
                            <br/><span style={{fontWeight:"100"}}>{this.props.userDetails.email}</span></p>
                            <img src={require("../../assets/img/"+this.props.userDetails.profilePic)} className="sidebar-profile-img" />
                            <p className="text-left " style={{fontWeight:"100",padding:"1rem 1rem 0rem 1rem",margin: "0px",fontSize: "0.8rem"}}>APPLICATIONS</p>
                        </div>
                        <div className="dropdown-divider"></div>
                    </div>
                   
                    {/* <hr className="sidebar-divider" /> */}

                    {this.props.sidebarMenus.map((menu) => {
                        return (
                            <NavLink to={{
                                pathname: "/" + menu.name,
                                hash: "",
                                search: "",

                            }}

                                activeClassName="sidebar-active"
                                key={menu.name}
                            >
                                <li >

                                    <i className={menu.icon}></i><span className="d-none d-sm-inline">{menu.name}</span>

                                </li>
                            </NavLink>);
                    })}
                </ul>
            </div>
        );
    }
}

export default SideBar;